import axiosInstance from "../../api/auth/axiosInstance";
 // replace with your actual API

export const searchDoctors =async  (keyword) => {
  try {
    const response = await axiosInstance.get(`/search/?q=${encodeURIComponent(keyword)}`, {
      headers: { authType: "PreLogin" },
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const searchDoctorsCategory =async  (keyword) => {
  try {
    const response = await axiosInstance.get(`/search/category-wise?q=${encodeURIComponent(keyword)}`, {
      headers: { authType: "PreLogin" },
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};